import { Controller } from "@hotwired/stimulus"

const ZIPCLOUD_URL = "https://zipcloud.ibsnet.co.jp/api/search"

// 郵便番号（7桁）から都道府県・市区町村・町域を zipcloud API で補完する
export default class extends Controller {
  static targets = ["postalCode", "prefecture", "city", "address1", "message"]

  onInput() {
    const zipcode = this.getWaInputValue(this.postalCodeTarget).replace(/\D/g, "")
    if (zipcode.length === 7) {
      this.fetchAndFillAddress(zipcode)
    }
  }

  async lookup() {
    const zipcode = this.getWaInputValue(this.postalCodeTarget).replace(/\D/g, "")
    if (zipcode.length !== 7) {
      this.clearMessage()
      return
    }

    await this.fetchAndFillAddress(zipcode)
  }

  async fetchAndFillAddress(zipcode) {
    try {
      const response = await fetch(`${ZIPCLOUD_URL}?zipcode=${encodeURIComponent(zipcode)}`)
      if (!response.ok) {
        this.showMessage("住所の取得に失敗しました。手入力してください。")
        return
      }

      const data = await response.json()
      if (data.status !== 200 || !data.results?.length) {
        this.showMessage("郵便番号が見つかりませんでした。")
        return
      }

      const result = data.results[0]
      this.setWaInputValue(this.prefectureTarget, result.address1 ?? "")
      this.setWaInputValue(this.cityTarget, result.address2 ?? "")
      this.setWaInputValue(this.address1Target, result.address3 ?? "")
      this.clearMessage()
    } catch {
      this.showMessage("住所の取得に失敗しました。手入力してください。")
    }
  }

  setWaInputValue(element, value) {
    element.value = value

    const internal = element.shadowRoot?.querySelector("input, textarea, select")
    if (internal) {
      internal.value = value
      internal.dispatchEvent(new Event("input", { bubbles: true }))
      internal.dispatchEvent(new Event("change", { bubbles: true }))
    }

    element.dispatchEvent(new Event("input", { bubbles: true }))
    element.dispatchEvent(new Event("change", { bubbles: true }))
  }

  getWaInputValue(element) {
    const internal = element.shadowRoot?.querySelector("input, textarea, select")
    return internal?.value ?? element.value ?? ""
  }

  showMessage(text) {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = text
    }
  }

  clearMessage() {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = ""
    }
  }
}
